import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid2";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React from "react";

const name = "AnonymousContent";

const AnonymousContent: React.FC = () => {

    return (
        (<Grid wrap="nowrap" container justifyContent="center" alignItems="center">
            <Grid container spacing={1} style={{ flexBasis: "100%" }}>
                <Grid width={"100%"}>
                    <Card>
                        <Paper elevation={4} sx={{ whiteSpace: "nowrap" }}>
                            {/* {loggedUser && loggedUser.role && <HomeChart role={loggedUser.role} />} */}
                            <Typography sx={{ fontWeight: "bolder" }} variant={"h5"}>RIGHTIO Booking System</Typography>
                        </Paper>
                        <Typography sx={{ m: 3 }} variant='subtitle1'>
                            Please <span style={{ fontStyle: "oblique", fontWeight: "bolder" }}>log in</span> to access the services provided.
                        </Typography>
                    </Card>
                </Grid>
                {/* <Paper elevation={4}>
                    <RightioLogo className='rightio-home-mini' />
                </Paper> */}
            </Grid>
        </Grid>)
    );

}

AnonymousContent.displayName = name;
export default AnonymousContent;